import { getUrlWithQueryParams } from '@helpers/productWidgetHelper'

export const ABHA_AADHAAR_LENGTH = 12
export const ABHA_OTP_LENGTH = 6

const AADHAAR_PATTERN = /^[1-9]\d{11}$/

export const sanitizeAadhaar = (value: string) => value.replace(/\D/g, '').slice(0, ABHA_AADHAAR_LENGTH)

export const formatAadhaarDisplay = (value: string) =>
  sanitizeAadhaar(value)
    .match(/.{1,4}/g)
    ?.join(' ') ?? ''

export const isValidAadhaarNumber = (value: string) => AADHAAR_PATTERN.test(sanitizeAadhaar(value))

export const getAbhaJourneyUrl = (phone: string, aadhar: string, otp?: string) => {
  const sanitizedAadhaar = sanitizeAadhaar(aadhar)
  const otpQuery = otp ? `&otp=${encodeURIComponent(otp)}` : ''

  return getUrlWithQueryParams(
    `/gi/p/health/newAbha?phone=${encodeURIComponent(phone)}&aadhar=${sanitizedAadhaar}${otpQuery}`
  )
}

export type AbhaCardPreviewData = {
  name: string
  dateOfBirth: string
  maskedAbhaNumber: string
  abhaNumber?: string
  abhaAddress: string
  profileImageUrl?: string
  relationshipLabel?: string
}

export const ABHA_MASKED_NUMBER_DISPLAY = '** _ **** _ **** _ ****'

export const formatAbhaNumberForDisplay = (value?: string) => {
  if (!value) return ''

  const trimmed = value.trim()

  if (/[–-]/.test(trimmed) && /\d\s*[–-]/.test(trimmed)) {
    return trimmed.replace(/\s*[-–]\s*/g, ' - ')
  }

  const digits = trimmed.replace(/\D/g, '')

  if (digits.length === 14) {
    return `${digits.slice(0, 2)} - ${digits.slice(2, 6)} - ${digits.slice(6, 10)} - ${digits.slice(10, 14)}`
  }

  if (digits.length === 12) {
    return `${digits.slice(0, 4)} - ${digits.slice(4, 8)} - ${digits.slice(8, 12)}`
  }

  if (digits.length === 10) {
    return `+91 - ${digits.slice(0, 4)} - ${digits.slice(4, 8)} - ${digits.slice(8, 10)}`
  }

  return trimmed
}
